/**
 * Line item priority order for direct stack sorting
 * Based on Google Ad Manager documentation:
 * https://support.google.com/admanager/answer/177279?hl=en
 *
 * Lower index = higher priority in ad selection
 */

// Priority order for direct stack line item types (highest to lowest priority)
const lineItemPriorityOrder = [
  'sponsorship', // Priority 4
  'preferred_deal', // Fixed high priority (between 4-6)
  'standard', // Priority 6, 8, 10
  'adsense', // Priority 12
  'ad_exchange', // Priority 12
  'network', // Priority 12, rank 1
  'bulk', // Priority 12, rank 2
  'price_priority', // Priority 12, rank 3
  'house', // Priority 16
  'admob', // Priority 16+
  'bumper', // Priority 16+
  'unknown', // Fallback for unrecognized types
];

// Get sort index for a line item type (lower = higher priority)
export const getLineItemSortIndex = lineItemType => {
  const index = lineItemPriorityOrder.indexOf(lineItemType);
  return index === -1 ? lineItemPriorityOrder.length : index;
};
